<template>
    <div class="overflow-hidden">
        <div class="GridLex-grid-noGutter-equalHeight">
            <div class="GridLex-col-6_sm-6_xs-12_xss-12 client">
                <div class="sell-or-buy">
                    <div class="icon">
                        <font-awesome-icon icon="briefcase"/>
                    </div>
                    <div class="clear"></div>
                    <div class="content">
                        <h3 class="uppercase">Cliente</h3>
                        <p>¿Buscas una sala de reuniones en cualquier destino? Registrate ahora y comienza a reservar
                            nuestras salas al mejor precio </p>
                        <router-link to="/catalogue">Ver Catálogo</router-link>
                    </div>
                </div>
            </div>
            <div class="GridLex-col-6_sm-6_xs-12_xss-12 owner">
                <div class="sell-or-buy">
                    <div class="icon">
                        <font-awesome-icon icon="building"/>
                    </div>
                    <div class="clear"></div>
                    <div class="content">
                        <h3 class="uppercase">Anfitrion</h3>
                        <p>¿Dispones de una sala de reuniones? Súbela ahora a nuestra plataforma y comienza a ganar
                            dinero</p>
                        <a href="#">Ser Anfitrión</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'profiles'
    }
</script>
<style scoped>
    .icon {
        color: #FFF !important;
        background: transparent !important;
    }

    .client {
        background: #8ea9ba !important;
    }

    .owner {
        background: #8ac6c4 !important;
    }
</style>